<div class="account-pages"></div>
<div class="clearfix"></div>
<div class="wrapper-page">
	<div class=" card-box">
		<div class="panel-heading text-center">
			<img src="/style/logo/1" alt="" style="width: 100%;"></img>
			<h3>{{TR "Firmenaccount anlegen"}}</h3>
			{{#if errors.error}}
				<div class="alert alert-danger">{{errors.error}}</div>
			{{/if}}
		</div>
		<div class="panel-body">
			<form class="form-horizontal m-t-20" action="#" method="post">
				<div class="form-group">
					<div class="col-xs-12">
						<input id="js-companyname-input" class="form-control {{#if errors.companyname}}parsley-error{{/if}}"
						type="text" name="register-companyname" placeholder="{{TR "Firmenname"}}" value="{{formData.register-companyname}}" autofocus>
						{{#if errors.companyname}}
						<ul class="parsley-errors-list filled" id="js-companyname-error">
							<li class="parsley-required">{{TR "Firmenname ist"}} {{errors.companyname}}</li>
						</ul>
						{{/if}}
					</div>
				</div>
				<div class="form-group">
					<div class="col-xs-6">
						<input id="js-subdomain-input" class="form-control {{#if errors.subdomain}}parsley-error{{/if}}"
						type="text" name="register-subdomain" placeholder="{{TR "Subdomäne"}}" value="{{formData.register-subdomain}}">
					</div>
					<div class="col-xs-6 form-control-static">
						<p>.trovis-team.com</p>
					</div>
					{{#if errors.subdomain}}
					<ul class="parsley-errors-list filled" id="js-subdomain-error">
						<li class="parsley-required">{{TR "Firmenname ist"}} {{errors.subdomain}}</li>
					</ul>
					{{/if}}
				</div>
				<div class="form-group m-t-30">
					<div class="col-xs-12">
						<input id="js-username-input" class="form-control {{#if errors.username}}parsley-error{{/if}}"
						type="text" name="register-username" placeholder="{{TR "Name"}}" value="{{formData.register-username}}">
						{{#if errors.username}}
						<ul class="parsley-errors-list filled" id="js-username-error">
							<li class="parsley-required">{{TR "Benutzername ist"}} {{errors.username}}</li>
						</ul>
						{{/if}}
					</div>
				</div>
				<div class="form-group">
					<div class="col-xs-12">
						<input id="js-email-input" class="form-control {{#if errors.email}}parsley-error{{/if}}"
						type="email" name="register-email" placeholder="{{TR "E-Mail"}}" value="{{formData.register-email}}">
						{{#if errors.email}}
						<ul class="parsley-errors-list filled" id="js-email-error">
							<li class="parsley-required">{{TR "E-Mail ist"}} {{errors.email}}</li>
						</ul>
						{{/if}}
					</div>
				</div>
				<div class="form-group">
					<div class="col-xs-12">
						<input id="js-password-input" class="form-control {{#if errors.password}}parsley-error{{/if}}"
						type="password" name="register-password" placeholder="{{TR "Passwort"}}" autocomplete="off">
						{{#if errors.password}}
						<ul class="parsley-errors-list filled" id="js-password-error">
							<li class="parsley-required">{{errors.password}}</li>
						</ul>
						{{/if}}
					</div>
				</div>
				<div class="form-group">
					<div class="col-xs-12">
						<div class="checkbox checkbox-primary {{#if errors.accept_terms}}form-control parsley-error{{/if}}">
							<input type="checkbox" id="js-register-terms-input" name="register-terms" {{#if formData.register-terms}}checked="checked"{{/if}}>
							<label for="register-terms">
								{{TR "Ich akzeptiere die"}} <a href="#" id="js-terms">{{TR "Nutzungsbedingungen"}}</a>.
							</label>
						</div>
						<div class="checkbox checkbox-primary {{#if errors.accept_gdpr}}form-control parsley-error{{/if}}">
							<input type="checkbox" id="js-register-gdpr-input" name="register-gdpr" {{#if formData.register-gdpr}}checked="checked"{{/if}}>
							<label for="register-gdpr">
								{{TR "Ich stimme der"}} <a href="#" id="js-gdpr">{{TR "Datenschutzhinweis"}}</a> {{TR "zu"}}.
							</label>
						</div>
					</div>
				</div>
				<div class="form-group text-center m-t-40">
					<div class="col-xs-12">
						<button class="js-signup btn btn-pink btn-block text-uppercase"
						type="submit">
							{{TR "Registrieren"}}
						</button>
					</div>
				</div>
				<div class="form-group m-t-30 m-b-0">
					<div class="col-xs-12">
						<div class="js-lang-menu pull-right" data-toggle="popover" data-html="true" data-content="{{TR_SELECTOR}}">
							{{TR 'Sprache'}}: <strong>{{lang}}</strong> <span class="caret"></span>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>

{{> PARTIAL_FOOTER}}
